import {
    type ApiResult,
    type BaseParams,
    type GetGroupMembersResponse,
    links,
    type PaginatedResult,
    type PostParams,
    Request,
    type ResourceId,
    type UpdateGroupMember,
} from '@app/client';
import { type CreateSocialGroup, type GroupMember, type SocialGroup, type UpdateSocialGroup } from '@app/gen';

export async function getCollection(params: BaseParams): Promise<ApiResult<PaginatedResult<SocialGroup>>> {
    //not going to rename this because it's in /admin
    return Request.getRequest<PaginatedResult<SocialGroup>>({
        ...params,
        target: links.pods.admin(),
    });
}

export async function create(params: BaseParams & PostParams<CreateSocialGroup>): Promise<ApiResult<SocialGroup>> {
    return Request.postRequest<SocialGroup>({
        ...params,
        target: links.pods.collection,
    });
}

export async function addMembers(
    params: BaseParams & PostParams<string[]> & { id: ResourceId },
): Promise<ApiResult<GetGroupMembersResponse>> {
    return Request.postRequest<GetGroupMembersResponse>({
        ...params,
        target: links.pods.single(params.id).members(),
    });
}

export async function updateGroup(
    params: BaseParams & PostParams<UpdateSocialGroup> & { id: ResourceId },
): Promise<ApiResult<SocialGroup>> {
    return Request.patchRequest<SocialGroup>({
        ...params,
        settings: {
            ...params.settings,
        },
        target: links.pods.single(params.id).group(),
    });
}

export async function updateGroupMember(
    params: BaseParams & PostParams<UpdateGroupMember> & { id: ResourceId; memberId: ResourceId },
): Promise<ApiResult<GroupMember>> {
    return Request.patchRequest<GroupMember>({
        ...params,
        settings: {
            ...params.settings,
        },
        target: links.pods.single(params.id).member(params.memberId),
    });
}

export async function removeGroup(params: BaseParams & { id: ResourceId }): Promise<ApiResult<SocialGroup>> {
    return Request.deleteRequest<SocialGroup>({
        ...params,
        target: links.pods.single(params.id).group(),
    });
}
export async function removeMember(
    params: BaseParams & { id: ResourceId; memberId: ResourceId },
): Promise<ApiResult<GroupMember>> {
    return Request.deleteRequest<GroupMember>({
        ...params,
        target: links.pods.single(params.id).member(params.memberId),
    });
}
